import { internalFetch } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface IWorkflow {
  id: number;
  name: string;
  url: string;
  trigger?: string;
  triggerType: string;
  entityType: string;
  dateField: string;
  beforeOrAfterDateField: string;
  dateTimeDiff: string;
  dateTimeDiff_Unit: string;
  otherInfo: string;
}

export interface IWorkflowExec {
  id: number;
  triggerType: string;
  entityType: string;
  dateField: string;
  beforeOrAfterDateField: string;
  dateTimeDiff: string;
  dateTimeDiff_Unit: string;
  triggeredAt?: Date;
  completedAt?: Date;
  status: string;
}

export interface ICreateWorkflowRequest {
  name: string;
  trigger?: string;
  entityType?: string;
  dateField?: string;
  beforeOrAfterDateField?: string;
  url: string;
  otherInfo?: string;
}

export interface IUpdateWorkflowRequest {
  name: string;
  trigger?: string;
  entityType?: string;
  dateField?: string;
  beforeOrAfterDateField?: string;
  url: string;
  otherInfo?: string;
}

export const getWorkflows = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IWorkflow>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/workflows?pageSize=${pageSize}&pageNo=${pageNo}${
      search ? `&search=${search}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const getWorkflow = async (
  abortController: AbortController,
  workflowId: number
): Promise<IWorkflow> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/workflow?workflowId=${workflowId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getWorkflowExec = async (
  abortController: AbortController,
  workflowExecId: number
): Promise<IWorkflowExec> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/workflowExecution?workflowExecutionId=${workflowExecId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const createWorkflow = async (
  abortController: AbortController,
  workflow: ICreateWorkflowRequest
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/workflow`,
    'POST',
    abortController,
    JSON.stringify(workflow)
  );
};

export const editWorkflow = async (
  abortController: AbortController,
  userId: number,
  user: IUpdateWorkflowRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/workflow?workflowId=${userId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(user)
  );
};

export const executeWorkflow = async (
  abortController: AbortController,
  workflowId: number
): Promise<number[]> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/execDateFieldBaseWorkflow?workflowId=${workflowId}`,
    'POST',
    abortController
  );
};

export const deleteWorkflow = async (
  abortController: AbortController,
  userId: number
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/workflow?workflowId=${userId}`,
    'DELETE',
    abortController
  );
};

export const getWorkflowExecs = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IWorkflowExec>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/workflowExecutions?pageSize=${pageSize}&pageNo=${pageNo}${
      search ? `&search=${search}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};
